import { Tenant, TenantType } from "generated/graphql";
import { RoleName } from "roles";

export const tenantTypeToTagsMap: Record<TenantType, string[]> = {
  ENTERPRISE: ["user-assignable"],
  SERVICE_PROVIDER: ["sp-user-assignable"],
  DISTRIBUTOR: ["disti-user-assignable"]
};

export const tenantTypeToDefaultRoleMap: Record<TenantType, RoleName> = {
  ENTERPRISE: "it-admin",
  SERVICE_PROVIDER: "sp-it-admin",
  DISTRIBUTOR: "disti-it-admin"
};

export type RelevantTenantInfo = Pick<Tenant, "id" | "name" | "type">;
